import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectInitialLoad, selectUser } from '../containers/App/selectors';

const useAuth = () => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const initialLoad = useSelector(selectInitialLoad);

  useEffect(() => {
    if (initialLoad && !user) {
      navigate('/');
    }
  }, [navigate, user, initialLoad]);

  return { user };
};

export { useAuth };
